"use client";

import { BlurFade } from "@/components/ui/blur-fade";
import { StylishText } from "@/components/ui/gradient-text";
import { WordRotate } from "@/components/ui/word-rotate";
import { useCommonTranslation } from "@/features/i18n/libs/useCommonTranslation";

export function ComprehensiveDiagnosisSection() {
  const { t } = useCommonTranslation();

  const changingWords = [
    t("landing:diagnosis_words_intellectual"),
    t("landing:diagnosis_words_physical"),
    t("landing:diagnosis_words_social"),
    t("landing:diagnosis_words_emotional"),
    t("landing:diagnosis_words_speech"),
    t("landing:diagnosis_words_sensorimotor"),
    t("landing:diagnosis_words_adaptive"),
    t("landing:diagnosis_words_creative"),
  ];

  const gradientWords = changingWords.map((word, index) => (
    <StylishText className="text-[30px]" key={index}>
      {word}
    </StylishText>
  ));

  return (
    <section className="text-center">
      <BlurFade delay={2.5}>
        <div />{" "}
        {/* does not show the whole block in e2e without it ........ suka */}
        <div className="mx-auto max-w-4xl text-h3 font-bold">
          <div>{t("landing:comprehensive_diagnosis_title")}</div>
          <div className="-my-2">
            <WordRotate duration={1500} words={gradientWords} />
          </div>
          <div>{t("landing:comprehensive_diagnosis_subtitle")}</div>
          <div className="text-lg font-normal">
            {t("landing:comprehensive_diagnosis_based")}
          </div>
        </div>
      </BlurFade>
    </section>
  );
}
